import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import a from '../../../../../redux/actions';
import s from '../../../../../redux/selectors';
import { wrap, withT } from '../../../../../lib/wrappers';

import InlineInput from '../InlineInput';

const EnergyStarPrinters = ({
  t,
  widgetSource,
}) => (
  <div className="action-details">
    <div className="action-details__form">
      <p>
        {t('I will replace')}
        <InlineInput
          maxLength={3}
          apiKey={'input_takeaction_energy_star_printers_amount'}
        />
        {t('conventional printers with Energy Star printers. I will purchase them for')}
        <InlineInput
          currency
          maxLength={6}
          apiKey={'input_takeaction_energy_star_printers_cost'}
        />
        {t('each.')}
      </p>
    </div>
    {widgetSource !== 'ontario' &&
      <div className="action-details__links">
        <a
          href="http://www.coolcalifornia.org/funding-wizard#search/energy+efficiency/%255BEligible+Applicants%253D%253DBusiness%255D/false/none/false/1/12"
          target="_blank"
          rel="noopener noreferrer"
        >{t('Find rebates and incentives for this action')}</a>
      </div>
    }
    <div className="action-details__assumptions">
      <div className="action-details__assumptions__header">{t('Assumptions')}</div>
      <ul>
        <li>
          {t('Annual energy savings:')}
          <InlineInput
            maxLength={3}
            apiKey="input_takeaction_energy_star_printers_annual_savings"
          />
          {t('kWh', { ns: 'units' })}
        </li>
      </ul>
    </div>
  </div>
);

EnergyStarPrinters.propTypes = {
  // wrapped
  t: PropTypes.func.isRequired,
  // connected props
  widgetSource: PropTypes.string.isRequired,
};

const mapStateToProps = (state, ownProps) => [].reduce((resultProps, resultKey) => ({
  ...resultProps,
  [resultKey]: s.results(resultKey)(state, ownProps),
}), {
  widgetSource: s.widgetSource(state),
});

const mapDispatchToProps = () => ({});

export default wrap(
  withT('energyStarPrinters'),
  connect(mapStateToProps, mapDispatchToProps)(EnergyStarPrinters),
);
